import { useEffect, useState } from 'react';

type UseSelectListReturnType<T> = {
  selectedList: T[];
  changeSelectList: (idList: number[]) => void;
};

interface UseSelectListProps<T> {
  list: T[];
  canMultiple?: boolean;
  value?: T[];
}

export const useSelectList = <T extends { id: number }>({
  list,
  canMultiple = false,
  value = [],
}: UseSelectListProps<T>): UseSelectListReturnType<T> => {
  const [selectedList, setSelectedList] = useState<T[]>([]);
  const currentList = list.map((item) => item.id);
  const prevPageSelected = selectedList.filter((item) => !currentList.includes(item.id));

  const changeSelectList = (selectedIdList: number[]): void => {
    if (canMultiple) {
      const currentPageSelected = list.filter((item) => selectedIdList.includes(item.id));
      const valueIdList = value.map((item) => item.id);
      const newList = [...prevPageSelected, ...currentPageSelected].filter((item) => !valueIdList.includes(item.id));

      setSelectedList([...newList, ...value]);
      return;
    }

    const lastSelected = list.find((item) => item.id === selectedIdList[selectedIdList.length - 1]);
    setSelectedList(lastSelected ? [lastSelected] : []);
  };

  useEffect(() => {
    if (value) {
      setSelectedList(canMultiple ? value : value.slice(-1));
    }
  }, []);

  return {
    selectedList,
    changeSelectList,
  };
};
